import React from "react"

import { Header } from "../components/header";
import { StudioManager } from "../studio-manager";

import './index.scss';

import { Search } from "../components/search/search";
import { SearchResults } from "../components/search/search-results";
import { MixcloudWidget } from "../components/mixcloud-widget/mixcloud-widget";
import { VideoOverlay } from "../components/youtube-overlay/youtube";
import { Helmet } from "react-helmet";
import { Footer } from "../components/footer";

const colors = ['#EFEFEF', '#E7E3F1', '#FFEDE4', '#FCFDE7', '#E5F5EE']; 

export default class Layout extends React.Component {
  constructor () {
    super();
    this.state = { isSearching: false, hasSearchResults: false, color: 0 }
  }

  componentDidMount () {
    StudioManager.instance.init();

    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-101794960-1', { 'anonymize_ip': true });

    StudioManager.instance.on('search-start', this.onSearchStart);
    StudioManager.instance.on('search-end', this.onSearchResult);
    window.main = this;
  }

  next = () => {
    var color = this.state.color + 1;
    if (color === colors.length) color = 0;
    this.setState({ color });
  }

  onSearchStart = () => {
    this.setState({ isSearching: true })
  }

  onSearchResult = () => {
    this.setState({ hasSearchResults: true })
  }

  closeSearch = () => {
    this.setState({ isSearching: false })
  }

  render = () => (
    <div>
      <Helmet>
        <title>Kiosk Radio</title>
        <link rel="icon" type="image/png" href="/favicon.png" />
        <meta name="description" content="We are an online community radio streaming 24/7 from a wooden shack in the heart of Brussels’ historic “Parc Royal”. A meeting point for music freaks from Brussels and beyond. A tiny kiosk bar serving eclectic music and drinks. Sometimes, in sunny summer days, a safe space to dance under the trees." />
        <meta property="og:image" content="https://kioskradio.com/images/kiosk-share.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>

      <style>{ `body, .filled { background-color: ${ colors[this.state.color] }; transition: background-color 800ms; }` }</style>
      
      <MixcloudWidget />
      <Header onSearch={ () => this.setState({ isSearching: !this.state.isSearching }) } />
      { this.state.isSearching && <Search onClose={this.closeSearch}/> }
      { (this.state.isSearching && this.state.hasSearchResults) && <SearchResults /> }

      { this.props.children }

      <Footer />

      <VideoOverlay />
    </div>
  );
}
